export { }

declare global {
	/**
	 * @interface Date
	 * @description Extencion del tipo de dato Date
	 */
	interface Date {
		isSameDate(date: Date): boolean;
		isTomorrowDate(date: Date): boolean;
		isOldDate(date: Date): boolean;
		startOfWeek(): Date;
		endOfWeek(): Date;
		diffWeeks(date: Date): number;
    diffMonth(date: Date): number;
		objDate(): { day: number; month: number; year: number; };
    setStringDate(date: string): void;
    setDateString(): string;
		setHoursStart(): Date;
    setHoursEnd(): Date;
    getMondays(): Date[];
    isDate(text: string): boolean;
    isWeekend(): boolean;
	}
}

(function () {
  /**
   * @description Valida si la fecha y la que se pasa por parametro son iguales
   * @param {Date} date Date to compare
   * @returns {boolean}
   * @example
   * a = new Date("2020-01-25");
   * b = new Date("2020-02-23");
   * a.isSameDate(b)
   * false
   */
  Date.prototype.isSameDate = function (date: Date): boolean {
    return date && this.getFullYear() === date.getFullYear() && this.getMonth() === date.getMonth() && this.getDate() === date.getDate();
  };

  /**
   * @description Valida si la fecha que se pasa por parametro es mayor que la que estamos comparando
   * @param {Date} date Tomorrow Date
   * @returns {boolean}
   * @example
   * a = new Date("2020-01-25");
   * b = new Date("2020-02-23");
   * a.isTomorrowDate(b)
   * false.
   */
  Date.prototype.isTomorrowDate = function (date: Date): boolean {
    return date && ((this.getFullYear() < date.getFullYear()) || (this.getFullYear() === date.getFullYear() && this.getMonth() < date.getMonth()) || (this.getFullYear() === date.getFullYear() && this.getMonth() === date.getMonth() && this.getDate() < date.getDate()));
  };

  /**
   * @description Valida si la fecha que se pasa por parametro es menor que la que estamos comparando
   * @param {Date} date Dater to compare
   * @returns {boolean}
   * @example
   * a = new Date("2020-01-25");
   * b = new Date("2020-02-23");
   * a.isOldDate(b)
   * false.
   */
  Date.prototype.isOldDate = function (date: Date): boolean {
    return date && ((this.getFullYear() > date.getFullYear()) || (this.getFullYear() === date.getFullYear() && this.getMonth() > date.getMonth()) || (this.getFullYear() === date.getFullYear() && this.getMonth() === date.getMonth() && this.getDate() > date.getDate()));
  };

  /**
   * @description Retorna el primer dia de la semana, se toma primer dia de la semana el domingo.
   * @returns {Date}
   * @example
   * a = 2021-02-12
   * a.startOfWeek()
   * 2021-02-07
   */
  Date.prototype.startOfWeek = function (): Date {
    const diff: number = this.getDate() - this.getDay() + (this.getDay() === 0 ? -7 : 0);
    return new Date(this.setDate(diff));
  }

  /**
   * @description Retorna el ultimo dia de la semana, se toma primer dia de la semana el domingo.
   * @returns {Date}
   * @example
   * a = 2021-02-12
   * a.startOfWeek()
   * 2021-02-13
   */
  Date.prototype.endOfWeek = function (): Date {
    const lastday: number = this.getDate() - this.getDay() + 6;
    return new Date(this.setDate(lastday));
  }

  /**
   * @description Retorna el valor absoluto de la cantidad de semanas que hay entre dos fechas.
   * @param {Date} date
   * @returns {number}
   */
  Date.prototype.diffWeeks = function (date: Date): number {
    let diff = (date.getTime() - this.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7);
    return Math.abs(Math.round(diff));
  }

  /**
   * @description Obtiene la diferencia de meses entre dos fechas.
   * @param {Date} date
   * @returns number
   */
  Date.prototype.diffMonth = function (date: Date): number {
    const year1 = this.getFullYear();
    const year2 = date.getFullYear();
    const month1 = this.getMonth();
    const month2 = date.getMonth();
    const numberOfMonths = (year2 - year1) * 12 + (month2 - month1);
    return numberOfMonths;
  }

  /**
   * @description pasa una fecha a un objeto con dia mes y año.
   * @return {{ day: number; month: number; year: number; }}
   */
  Date.prototype.objDate = function (): { day: number; month: number; year: number; } {
    const retorno: { day: number; month: number; year: number; } = { day: this.getDate(), month: this.getMonth() + 1, year: this.getFullYear() };
    return retorno;
  }

  /**
   * @description Convierte una fecha de string a Date
   * @param {Date} date
   */
  Date.prototype.setStringDate = function (date: string): void {
    const d: string[] = date.split('-');
    this.setFullYear(+d[0], +d[1] - 1, +d[2]);
    //this.setDate(+d[2]);
    //this.setMonth(+d[1] - 1);
    //this.setFullYear(+d[0]);
  }

  /**
   * @description Convierte una fecha de string a Date.
   * @returns {string}
   */
  Date.prototype.setDateString = function (): string {
    return this.getFullYear() + "-" + ("00" + (this.getMonth() + 1)).slice(-2) + "-" + ("00" + this.getDate()).slice(-2);
  }

  /**
   * @description Setea hora a 0.
   * @returns {Date}
   */
  Date.prototype.setHoursStart = function (): Date {
    return new Date(this.setHours(0, 0, 0, 0));
  }

  /**
   * @description Setea la hora maxima del dia 23:59:59.999
   * @return {Date}
   */
  Date.prototype.setHoursEnd = function (): Date {
    return new Date(this.setHours(23, 59, 59, 999));
  }

  /**
   * @description Obtiene una lista de los lunes de un mes.
   * @returns {Date[]}
   */
  Date.prototype.getMondays = function (): Date[] {
    let d: Date = new Date(this);
    d = new Date((d.setHoursStart()).setDate(1));
    let weekDay: number;

    const mondayList: Date[] = [];
    while (d.getMonth() === this.getMonth()) {
      weekDay = d.getDay();
      if (weekDay === 1) {
        mondayList.push(new Date(d));
        d.setDate(d.getDate() + 7);
      } else if (weekDay === 0) {
        d.setDate(d.getDate() + 1);
      } else {
        // weekDay > 1
        d.setDate(d.getDate() + (8 - weekDay));
      }
    }

    return mondayList;
  }

  /**
   * @description Validatio string is date.
   * @param {string} text Texto para validar si es formato de fecha
   * @returns {boolean}
   */
  Date.prototype.isDate = function (text: string): boolean {
    if (text === null || text === undefined) return false;
    if (toString.call(text) === '[object Date]') {
      return true;
    }
    if (typeof text.replace === 'function') {
      text.replace(/^\s+|\s+$/gm, '');
    }
    /* eslint-disable-next-line */
    const dateFormat = /(^\d{1,4}[\.|\\/|-]\d{1,2}[\.|\\/|-]\d{1,4})(\s*(?:0?[1-9]:[0-5]|1(?=[012])\d:[0-5])\d\s*[ap]m)?$/;
    return dateFormat.test(text);
  }

  /**
   * @description Validation Date is weekend.
   * @returns {boolean}
   */
  Date.prototype.isWeekend = function (): boolean {
    const d: Date = new Date(this);
    return (d.getDay() == 6 || d.getDay() == 0);
  }
})();
